import { useState } from "react";
import PageContainer from "../../Component/Common/Page";
import PageHeader from "../../Component/Common/PageHeader";
import MultiButton from "../../Component/extra/MultiButton";
import AllPlans from "./AllPlans";
import CreatePlan from "./CreatePlan";

const TABS = {
  TAB1: "All Plans",
  TAB2: "Create Plan",
};

const SubscriptionsPlanPage = () => {
  const [currentTab, setCurrentTab] = useState(TABS.TAB1);

  return (
    <PageContainer>
      <PageHeader heading={"Welcome Admin"} subHeading={"Subscription Plans"} />

      <MultiButton
        label={[TABS.TAB1, TABS.TAB2]}
        multiButtonSelect={currentTab}
        setMultiButtonSelect={setCurrentTab}
      />

      {currentTab === TABS.TAB1 && (
        <AllPlans changeTab={() => setCurrentTab(TABS.TAB2)} />
      )}
      {currentTab === TABS.TAB2 && (
        <CreatePlan changeTab={() => setCurrentTab(TABS.TAB1)} />
      )}
    </PageContainer>
  );
};

export default SubscriptionsPlanPage;
